// extracted by mini-css-extract-plugin
export default {"text":"success_text__d35c3"};